module.exports = __webpack_public_path__ + "img/2.f2724c43.png";